/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'quote2': {
    width: 19,
    height: 14,
    viewBox: '0 0 19 14',
    data: '<path pid="0" d="M0 11.813C2.484 10.6 3.727 9.171 3.727 7.531 2.667 7.41 1.792 6.98 1.1 6.241.407 5.5.06 4.646.06 3.675c0-1.033.336-1.903 1.008-2.612C1.741.354 2.586 0 3.605 0c1.14 0 2.128.46 2.963 1.382.834.921 1.252 2.04 1.252 3.356 0 3.947-2.22 7.035-6.66 9.262L0 11.813zm11.18 0c2.505-1.214 3.757-2.642 3.757-4.282-1.079-.121-1.965-.551-2.657-1.29-.693-.74-1.039-1.595-1.039-2.566 0-1.033.341-1.903 1.023-2.612C12.947.354 13.797 0 14.815 0c1.14 0 2.123.46 2.948 1.382.825.921 1.237 2.04 1.237 3.356 0 3.947-2.21 7.035-6.629 9.262l-1.19-2.187z" _fill="#FFD500" fill-rule="evenodd"/>'
  }
})
